import { useGlobalListeners } from '@react-aria/utils';
import { useEffect, useState } from 'react';

export function useIsAltPressed() {
  const { addGlobalListener, removeGlobalListener } = useGlobalListeners();
  const [isAltPressed, setIsAltPressed] = useState(false);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.key === 'Alt') {
        event.preventDefault();
        setIsAltPressed(true);
      }
    }

    function handleKeyUp(event) {
      if (event.key === 'Alt') {
        event.preventDefault();
        setIsAltPressed(false);
      }
    }

    addGlobalListener(window, 'keydown', handleKeyDown);
    addGlobalListener(window, 'keyup', handleKeyUp, true);

    return function () {
      removeGlobalListener(window, 'keydown', handleKeyDown);
      removeGlobalListener(window, 'keyup', handleKeyUp, true);
    };
  }, [addGlobalListener, removeGlobalListener]);

  return isAltPressed;
}
